import React, {type ReactNode} from "react";
import type {UrlObject} from "url";
import type {Locale} from "~/i18n-config";
import {LangLink} from "~/components/locales/LangLink";
import clsx from "clsx";

export function PrimaryButtonLink(
    { lang, href, label, className } : { lang: Locale, href: string | UrlObject, label: ReactNode, className?: string }
) {
    return (
        <LangLink lang={lang} href={href} className={clsx("inline-flex items-center justify-center px-6 py-3 rounded-md text-center font-jost font-semibold outline-2 outline-offset-2 transition-colors text-lg text-white bg-black hover:bg-black/80 whitespace-nowrap", className)}>
            {label}
        </LangLink>
    )
}
